import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import LoginView from '../views/LoginView.vue'
import MasterLayout from '../layouts/Master.vue'
import Dashboard from '../views/Dashboard/Dashboard.vue'
import Home from '../views/Setup/Home.vue'
import SetupListView from '../views/Setup/SetupListView.vue'
import Input from '../views/Input/FormInput.vue'
import Admin from '../views/Admin/AdminSetup.vue'
import Super from '../views/SuperAdmin/SuperSetup.vue'
import ChangePassword from '../views/ChangePassword.vue'
import ChangePasswordPanel from '../views/Profile/ChangePassword.vue'
import AccountSettings from '../views/Profile/AccountSettings.vue'
import SubDetailPage from '../views/Setup/SubDetailPage.vue'
import AccountingTargetPage from '../views/Setup/AccountingTargetPage.vue'
import ProgressInputKPI from '../views/Report/ProgressInputKPI.vue'
import ScoreRecap from '../views/Report/ScoreRecap.vue'

Vue.use(VueRouter)
function findFirstActiveRoute(menus) {
  for (const menu of menus) {
    if (menu.is_active === 1 && menu.route) return menu.route
    if (menu.children && Array.isArray(menu.children)) {
      const child = menu.children.find(c => c.is_active === 1 && c.route)
      if (child) return child.route
    }
  }
  return null
}
function checkAuth(to, from, next) {
  const token = store.getters.isTokenUser
  const menus = store.getters.getMenus
  const path = to.matched[0].path

  if (!token) return next({ path: '/' })

  const allowed = menus.some(menu => {
    if (menu.is_active !== 1) return false
    if (menu.route === path) return true
    if (menu.children && Array.isArray(menu.children)) {
      return menu.children.some(child => child.is_active === 1 && child.route === path)
    }
    return false
  })

  if (allowed) {
    return next()
  } else {
    alert('Anda tidak memiliki akses ke halaman ini.')


    const redirectPath = findFirstActiveRoute(menus)
    if (redirectPath) {
      return next(redirectPath)
    } else {
      return next('/')
    }
  }
}

// Dipakai untuk halaman akun pribadi (mis. Change Password) yang harus bisa
// diakses SEMUA role begitu login, tanpa perlu di-setting sebagai menu per-role.
function checkAuthOnly(to, from, next) {
  const token = store.getters.isTokenUser
  if (!token) return next({ path: '/' })
  return next()
}


const routes = [
  {
    path: '/',
    name: 'LoginView',
    component: LoginView
    
  },
  {
    path: '/changepassword',
    name: 'ChangePassword',
    component: ChangePassword
  },
  {
    path: '/dashboard',
    component: MasterLayout,
    beforeEnter: checkAuth,
    children: [
      {
        path: '',
        name: 'dashboard',
        component: Dashboard
      }
    ]
  },
  {
    path: '/home',
    component: MasterLayout,
    beforeEnter: checkAuth,
    children: [
      {
        path: '',
        name: 'home',
        component: Home
      },
      {
      path: 'subdetail/:kpiPeriodeId/:chartId?',
      name: 'subdetail',
      component: SubDetailPage,
      props: true
    },
      {
      path: 'accounting-target/:chartId',
      name: 'accounting-target',
      component: AccountingTargetPage,
      props: true
    }
    ]
  },
  {
    path: '/setup-list',
    component: MasterLayout,
    beforeEnter: checkAuth,
    children: [
      {
        path: '',
        name: 'setup-list',
        component: SetupListView
      }
    ]
  },
  {
    path: '/change-password',
    component: MasterLayout,
    beforeEnter: checkAuthOnly,
    children: [
      {
        path: '',
        name: 'change-password',
        component: ChangePasswordPanel
      }
    ]
  },
  {
    path: '/account-settings',
    component: MasterLayout,
    beforeEnter: checkAuthOnly,
    children: [
      {
        path: '',
        name: 'account-settings',
        component: AccountSettings
      }
    ]
  },
  {
    path: '/input',
    component: MasterLayout,
    beforeEnter: checkAuth,
    children: [
      {
        path: '',
        name: 'input',
        component: Input
      }
    ]
  },
  {
    path: '/adminmanagement',
    component: MasterLayout,
    beforeEnter: checkAuth,
    children: [
      {
        path: '',
        name: 'admin',
        component: Admin
      }
    ]
  },
  {
    path: '/superadmin',
    component: MasterLayout,
    beforeEnter: checkAuth,
    children: [
      {
        path: '',
        name: 'super',
        component: Super
      }
    ]
  },
  {
    path: '/report-progress-input',
    component: MasterLayout,
    beforeEnter: checkAuth,
    children: [
      {
        path: '',
        name: 'report-progress-input',
        component: ProgressInputKPI
      }
    ]
  },
  {
    path: '/report-score-recap',
    component: MasterLayout,
    beforeEnter: checkAuth,
    children: [
      {
        path: '',
        name: 'report-score-recap',
        component: ScoreRecap
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  const token = store.getters.isTokenUser
  const user = store.getters.getUser
  if (!token && to.path === '/') {
    return next()
  }
  if (!token && to.path !== '/') {
    return next('/')
  }
  if (token && user.is_password_changed === 0 && to.path !== '/changepassword') {
    return next('/changepassword')
  }
  next()
})

export default router
